import React from "react";
import "./styles.css";

let FareTable = ({
  numberOfETickets,
  installmentDates,
  installment,
  totalCost,
  flightCost,
  fee
}) => {
  const renderPaymentDates = installmentDates.map((installmentDate, i) => (
    <tr key={installmentDate}>
      <td>{installmentDate}</td>
      <td class="right-col">${installment}</td>
    </tr>
  ));

  return (
    <div>
      <div>
        <section>
          <h6 class="section-header">Payment Schedule</h6>
          <table class="fare-table">
            <tbody>
              {renderPaymentDates}
              <tr class="total-row">
                <td>Total Price</td>
                <td class="right-col">${totalCost}</td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </div>
  );
};

export default FareTable;



// WEBPACK FOOTER //
// ./src/components/PaymentSchedule/index.js